import React, { Component } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    IconButton,
    Button,
    Grid,
    MenuItem,
    Collapse,
    Switch,
    Divider,
    Tab,
    Tabs
} from '@mui/material';
import {
    Add as AddIcon,
    Close as CloseIcon,
    InventoryOutlined as InventoryIcon,
    CollectionsOutlined as CollectionsIcon,
    KeyboardArrowDown as ArrowDownIcon,
    KeyboardArrowUp as ArrowUpIcon,
    Check,
    Launch,
    FormatSizeOutlined,
    PaletteOutlined,
    DeleteOutline
} from '@mui/icons-material';
import LayersIcon from '@mui/icons-material/Layers';
import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { apiUrl } from '../../comp/ApiUrl';
import { WithRouter } from '../../comp/WithRouter';
import { toast } from 'react-toastify';
import GerenciadorVariacoes from '../../comp/VariacoesProduto';

class NovoProduto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Bloco de Fotos
            activeTab: 0,
            fotos: [],
            categorias: [],
            // Bloco de Informações Básicas
            nome: '',
            descricao: '',
            categoria: '',
            subcategoria: '',
            marca: '',
            sku: '',
            destaque: 0,
            quantidade: 1,
            isLoading: false,
            isSubmitting: false, // Previne clique duplo no botão de salvar
            // Controle de interface do sanfonado (Collapse)
            expandidoOpcional: true,
            precoVenda: '',
            precoOriginal: '',
            precoSobConsulta: false,

            // Configurar preço de atacado
            expandidoAtacado: false,
            venderAtacado: true,
            exibirApenasAtacado: false,
            precoAtacado: '',
            qtdMinima: 3,
            unidade: 'UN'
        };
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        document.title = 'Novo Produto';
        fetch(`${apiUrl}/produtos/prorpriedades`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    response.json().then((data) => {
                        this.setState({
                            categorias: data.categorias || [],
                        });
                    });
                }
            })
            .catch((error) => {
                console.error("Erro ao buscar propriedades do produto:", error);
            });
    }

    stringToNumber = (value) => {
        if (!value) return 0;
        const cleanValue = value.replace(/\D/g, "");
        return parseFloat(cleanValue) / 100;
    };

    numberToBRL = (value) => {
        if (value === undefined || value === null || isNaN(value)) return "";
        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        }).format(value);
    };

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleSwitchChange = (event) => {
        const { name, checked } = event.target;
        this.setState({ [name]: checked });
    };

    toggleOpcionais = () => {
        this.setState((prevState) => ({ expandidoOpcional: !prevState.expandidoOpcional }));
    };

    handleRemoverFoto = (id) => {
        this.setState((prevState) => {
            const novasFotos = prevState.fotos.filter((foto) => foto.id !== id);
            const tinhaPrincipal = prevState.fotos.find(f => f.id === id)?.principal;
            if (tinhaPrincipal && novasFotos.length > 0) {
                novasFotos[0].principal = true;
            }
            return { fotos: novasFotos };
        });
    };

    handleFileChange = async (event) => {
        const files = Array.from(event.target.files);
        if (files.length === 0) return;

        const formData = new FormData();
        files.forEach((file) => {
            formData.append("images", file);
        });

        try {
            const response = await fetch(`${apiUrl}/products/upload-images`, {
                method: "POST",
                credentials: "include",
                body: formData,
            });

            const data = await response.json();

            if (data.success && data.imagens) {
                this.setState((prevState) => {
                    const novasFotos = data.imagens.map((img, index) => ({
                        id: img.id,
                        name: img.name,
                        url: `${img.name}`,
                        principal: prevState.fotos.length === 0 && index === 0
                    }));
                    return { fotos: [...prevState.fotos, ...novasFotos] };
                });
            } else {
                toast.error(data.message || "Falha ao enviar imagens.");
            }
        } catch (error) {
            console.error("Erro no upload de fotos:", error);
            toast.error("Erro de conexão ao enviar imagens.");
        }

        event.target.value = '';
    };

    triggerFileSelect = () => {
        this.fileInputRef.current.click();
    };

    handleImageUrlFromLink = async (imageUrl) => {
        if (!imageUrl) return;

        try {
            const imageResponse = await fetch(imageUrl);
            if (!imageResponse.ok) throw new Error("Não foi possível acessar a URL da imagem.");

            const blob = await imageResponse.blob();
            const filename = imageUrl.split('/').pop().split('?')[0] || "imagem_enviada.jpg";
            const file = new File([blob], filename, { type: blob.type });

            const formData = new FormData();
            formData.append("images", file);

            const response = await fetch(`${apiUrl}/products/upload-images`, {
                method: "POST",
                credentials: "include",
                body: formData,
            });

            const data = await response.json();

            if (data.success && data.imagens) {
                this.setState((prevState) => {
                    const novasFotos = data.imagens.map((img, index) => ({
                        id: img.id,
                        name: img.name,
                        url: `${img.name}`,
                        principal: prevState.fotos.length === 0 && index === 0
                    }));
                    return { fotos: [...prevState.fotos, ...novasFotos] };
                });
            }
        } catch (error) {
            console.error("Erro no upload da imagem por URL:", error);
            toast.error("Erro ao processar ou enviar a imagem da URL.");
        }
    };

    handleBarcodeSearch = async (barcode) => {
        const cleanBarcode = barcode ? barcode.trim() : '';
        if (!cleanBarcode || this.state.isLoading) return;

        this.setState({ isLoading: true });

        try {
            const response = await fetch(`https://api.fazpedido.com.br/product/inquiry/${cleanBarcode}`);

            if (!response.ok) {
                throw new Error('Produto não encontrado');
            }

            const data = await response.json();

            if (data.imagem !== null) {
                this.handleImageUrlFromLink(`https://sparkling-truth-12fc.contato-05c.workers.dev/?url=${data.imagem}`);
            }

            this.setState({
                nome: data.nome || this.state.nome,
                isLoading: false
            });
            toast.success("Dados do produto preenchidos com sucesso!");
        } catch (error) {
            console.error('Erro ao buscar produto:', error);
            this.setState({ isLoading: false });
            toast.error('Produto não encontrado ou erro na busca.');
        }
    };

    // Validação e Envio dos Dados
    handleProximoPasso = async () => {
        const { nome, descricao, categoria, sku, marca, destaque, isSubmitting } = this.state;

        // Evita múltiplos cliques simultâneos
        if (isSubmitting) return;

        // Validação de campos obrigatórios
        if (!nome || !nome.trim()) {
            toast.warning("Por favor, preencha o Nome do produto.");
            return;
        }

        this.setState({ isSubmitting: true });

        try {
            const response = await fetch(`${apiUrl}/products/set/v2/`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    nome: nome.trim(),
                    descricao,
                    categoria,
                    sku,
                    marca,
                    destaque,
                }),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                toast.success("Produto cadastrado! Avançando para as fotos...");
                this.props.navigate(`/produtos/${data.uuid}/photos`);
            } else {
                toast.error(data.message || "Erro ao salvar os dados do produto.");
            }
        } catch (error) {
            console.error("Erro ao salvar produto:", error);
            toast.error("Erro de comunicação com o servidor. Tente novamente.");
        } finally {
            this.setState({ isSubmitting: false });
        }
    };

    render() {
        const {
            nome,
            descricao,
            categoria,
            categorias,
            marca,
            sku,
            isLoading,
            isSubmitting,
            destaque,
            expandidoOpcional,
            activeTab
        } = this.state;

        const isFormValid = nome.trim().length > 0;

        const inputStyle = {
            '& .MuiOutlinedInput-root': {
                backgroundColor: '#f8fafc',
                borderRadius: 2,
                '& fieldset': { borderColor: '#e2e8f0' },
                '&:hover fieldset': { borderColor: '#cbd5e1' },
                '&.Mui-focused fieldset': { borderColor: '#9966f1' }
            },
            '& .MuiOutlinedInput-input::placeholder': {
                color: '#94a3b8',
                opacity: 1
            }
        };

        return (
            <Box sx={{ p: 0, backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                <input
                    type="file"
                    multiple
                    accept="image/*"
                    ref={this.fileInputRef}
                    style={{ display: 'none' }}
                    onChange={this.handleFileChange}
                />

                {/* Header */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4 }}>
                    <Box>
                        <Typography variant="h5" fontWeight="700" gutterBottom>
                            Novo Produto
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Cadastre um novo produto
                        </Typography>
                    </Box>
                </Box>

                {/* Tabs */}
                <Box sx={{ mb: 4 }}>
                    <Tabs
                        value={activeTab}
                        onChange={this.handleTabChange}
                        sx={{
                            '& .MuiTabs-indicator': { display: 'none' },
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                minHeight: '40px',
                                borderRadius: '8px',
                                mr: 1,
                                fontWeight: 500,
                                color: '#666'
                            },
                            '& .Mui-selected': {
                                bgcolor: '#fff',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                color: '#000 !important'
                            }
                        }}
                    >
                        <Tab icon={<InventoryIcon sx={{ color: '#9c27b0' }} />} iconPosition="start" label="Informações Básicas" />
                        <Tab icon={<CollectionsIcon sx={{ color: '#9c27b0' }} />} iconPosition="start" label="Fotos do Produto" />
                        <Tab icon={<AttachMoneyIcon sx={{ color: '#9c27b0' }} />} iconPosition="start" label="Preço" />
                        <Tab icon={<LayersIcon sx={{ color: '#9c27b0' }} />} iconPosition="start" label="Atributos & Variações" />
                    </Tabs>
                </Box>

                {/* INFORMAÇÕES BÁSICAS */}
                <Card sx={{ borderRadius: 3, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)', border: '1px solid #e2e8f0' }}>
                    <CardContent sx={{ p: 3 }}>

                        {/* Header do Card */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                            <Box sx={{ bgcolor: '#f3e5f5', p: 1, borderRadius: 2, display: 'flex' }}>
                                <InventoryIcon sx={{ color: '#9c27b0' }} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                    Informações básicas
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                    Nome, descrição e categoria
                                </Typography>
                            </Box>
                        </Box>

                        {/* Campo: Nome do produto */}
                        <Box sx={{ mb: 2.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                Nome do produto <span style={{ color: '#ef4444' }}>*</span>
                            </Typography>
                            <TextField
                                fullWidth
                                name="nome"
                                value={nome}
                                onChange={this.handleInputChange}
                                placeholder="Ex: Vestido Floral Primavera"
                                variant="outlined"
                                size="small"
                                error={!nome && isSubmitting}
                                helperText={!nome && isSubmitting ? "O nome do produto é obrigatório" : ""}
                                sx={inputStyle}
                            />
                        </Box>

                        {/* Campo: Descrição */}
                        <Box sx={{ mb: 2.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                Descrição
                            </Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                name="descricao"
                                value={descricao}
                                onChange={this.handleInputChange}
                                placeholder="Escreva os detalhes, tecido, medidas..."
                                variant="outlined"
                                size="small"
                                inputProps={{ maxLength: 1500 }}
                                sx={inputStyle}
                            />
                            <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5 }}>
                                {descricao.length}/1500
                            </Typography>
                        </Box>

                        {/* Grid: Categoria */}
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                            <Grid item size={{ xs: 12, md: 4 }}>
                                <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                    Categoria
                                </Typography>
                                <TextField
                                    select
                                    fullWidth
                                    name="categoria"
                                    value={categoria}
                                    onChange={this.handleInputChange}
                                    variant="outlined"
                                    size="small"
                                    displayEmpty
                                    sx={inputStyle}
                                >
                                    <MenuItem value="">Selecione uma categoria</MenuItem>
                                    {categorias.map((cat) => (
                                        <MenuItem key={cat.id} value={cat.id}>{cat.nome}</MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </Grid>

                        {/* Seletor Desdobrável: Marca, código e destaque */}
                        <Box sx={{ mb: 1 }}>
                            <Button
                                onClick={this.toggleOpcionais}
                                startIcon={expandidoOpcional ? <ArrowUpIcon fontSize="small" /> : <ArrowDownIcon fontSize="small" />}
                                sx={{
                                    textTransform: 'none',
                                    color: '#64748b',
                                    fontWeight: '500',
                                    fontSize: '0.875rem',
                                    p: 0,
                                    '&:hover': { bgcolor: 'transparent', color: '#475569' }
                                }}
                            >
                                Marca, código e destaque (opcional)
                            </Button>
                        </Box>

                        <Collapse in={expandidoOpcional}>
                            <Grid container spacing={2} sx={{ mt: 0.5 }}>
                                {/* Campo: Marca */}
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Marca
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="marca"
                                        value={marca}
                                        onChange={this.handleInputChange}
                                        placeholder="Ex: Nike"
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                    />
                                </Grid>

                                {/* Campo: Código/SKU */}
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Código/SKU
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="sku"
                                        value={sku}
                                        onChange={(e) => this.setState({ sku: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                this.handleBarcodeSearch(this.state.sku);
                                            }
                                        }}
                                        placeholder="Ex: SKU-123"
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                        InputProps={{
                                            endAdornment: isLoading ? (
                                                <InputAdornment position="end">
                                                    <CircularProgress size={20} color="inherit" />
                                                </InputAdornment>
                                            ) : null,
                                        }}
                                        disabled={isLoading}
                                    />
                                </Grid>

                                {/* Campo: Destaque */}
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Destaque
                                    </Typography>
                                    <TextField
                                        select
                                        fullWidth
                                        name="destaque"
                                        value={destaque}
                                        onChange={this.handleInputChange}
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                    >
                                        <MenuItem value="0">Nenhum</MenuItem>
                                        <MenuItem value="1">Novidade</MenuItem>
                                        <MenuItem value="2">Promoção</MenuItem>
                                        <MenuItem value="3">Mais Vendido</MenuItem>
                                        <MenuItem value="4">Últimas Unidades</MenuItem>
                                    </TextField>
                                </Grid>
                            </Grid>
                        </Collapse>

                    </CardContent>
                </Card>

                {/* Ações / Botão Próximo Passo */}
                <Card sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', p: 3, mt: 3, borderRadius: 3, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)', border: '1px solid #e2e8f0' }}>
                    <Button
                        variant="contained"
                        onClick={this.handleProximoPasso}
                        disabled={!isFormValid || isSubmitting}
                        startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : <Check />}
                        sx={{
                            borderRadius: '8px',
                            textTransform: 'none',
                            px: 3,
                            py: 1
                        }}
                    >
                        {isSubmitting ? 'Salvando...' : 'Próximo Passo'}
                    </Button>
                </Card>
            </Box>
        );
    }
}

export default WithRouter(NovoProduto);